(() => {
  const nativeEntities = new Map();
  document.querySelectorAll('[data-color-browse-data]').forEach((node) => {
    try {
      JSON.parse(node.textContent).forEach((product) => {
        const variants = product.variants || [];
        if (!variants.length) return;
        const url = new URL(variants[0].url, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return;
        nativeEntities.set(url.pathname, {
          productId: String(product.id),
          variantIds: new Set(variants.map((variant) => String(variant.id))),
          defaultId: url.origin + url.pathname + (variants.length > 1 ? '#product-group' : '#variant-' + variants[0].id)
        });
      });
    } catch (_) {}
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.nyt-mobile-menu[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary')?.focus();
    event.preventDefault();
  });
  document.addEventListener('nytarp:catalog-updated', (event) => {
    const list = document.getElementById('nytarp-collection-items');
    if (!list || !Array.isArray(event.detail?.products)) return;
    const items = event.detail.products.flatMap((product) => {
      try {
        const url = new URL(product.url, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return [];
        const item = { '@type': 'ListItem', name: product.title, url: url.href };
        const native = nativeEntities.get(url.pathname);
        if (native && native.productId === String(product.id)) {
          const variantId = url.searchParams.get('variant');
          if (variantId && !native.variantIds.has(variantId)) return [];
          item.item = { '@id': variantId ? url.origin + url.pathname + '#variant-' + variantId : native.defaultId };
        }
        return [item];
      } catch (_) {
        return [];
      }
    }).map((item, index) => ({ ...item, position: index + 1 }));
    try {
      const graph = JSON.parse(list.textContent);
      graph.mainEntity.itemListElement = items;
      graph.mainEntity.numberOfItems = items.length;
      list.textContent = JSON.stringify(graph);
    } catch (_) {}
  });
})();
